module.exports = __webpack_public_path__ + "bb.svg?0c916c1c17d5652f5e92b773aa1d4e2a";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/1x1/bb.svg
// module id = 1245
// module chunks = 0